<div class="managed-cont">
<!-- <span class="managed-services">Services names:</span>&nbsp;
<select class="manageg-slt">
    <option>service name</option>
</select> -->
<h2 class="heading-adfsclient">{{'Global Managed Services'|translate}}</h2><br>
<!-- <p class="p-adfsclient">Registered ADFS clients that are set and allowed to acccess webservices via Etis</p> -->
<table class="table managed-tab">
    <thead  class="managed-services">
      <tr>
        <th> {{'Services names'|translate}}</th>
        <th >{{'Blackout rules'|translate}}</th>
        <!-- <th> Parameter</th> -->
      
        
      </tr>
    </thead>
    <tbody class="managed-services-tbody">
      <tr *ngFor="let service of serviceNameList">
        <td >{{service.serviceName}}</td>
        <td ><button  class="managed-btn" name="uploadXml"  (click)="showRules(service.serviceName,service.id)">{{'Show Rules'|translate}}</button></td>
        <!-- <td ><input  type="submit" name="uploadXml" value="Update"></td> -->
       
      
      </tr>
    
    </tbody>
  </table>
</div>
